<template>
  <div
    class="zm-checkbox-list"
    role="group"
    tabindex="0"
    :aria-activedescendant="activedescendant"
    @keydown="handleKeyDown"
    @focus="onFocus"
  >
    <zm-row v-for="(row,indexY) in splitItems" :key="indexY" class="zm-checkbox-list__row">
      <zm-col :span="span" v-for="(cell,indexX) in row" :key="indexX">
        <zm-checkbox
          :label="cell.label"
          :disabled="cell.disabled"
          :aria-label="computeAriaLabel(cell,indexY,indexX)"
          :name="cell.displayName"
          :x="indexX"
          :y="indexY"
          ref="checkbox"
        >
          <template v-if="!$scopedSlots.default">
            {{cell.displayName || cell.label}}
          </template>
          <slot :item="cell">
          </slot>
        </zm-checkbox>
      </zm-col>
    </zm-row>
  </div>
</template>

<script>
  import Emitter from '../../mixins/emitter';
  import ZmRow from '../row';
  import ZmCol from '../col';
  import ZmCheckbox from '../checkbox';
  import NavigationMixin from './navigation-mixin';
  import AriaUtils from '../../utils/aria-utils';

  export default {
    name: 'ZmCheckboxList',

    componentName: 'ZmCheckboxList',

    mixins: [Emitter, NavigationMixin],

    components: {
      ZmRow,
      ZmCol,
      ZmCheckbox
    },

    inject: {
      ZmFormItem: {
        default: ''
      }
    },

    props: {
      value: [Array, String],
      items: {
        type: Array,
        default() {
          return [];
        }
      },
      columnCount: {
        type: Number,
        default: 1
      },
      span: {
        type: Number,
        default: 6
      },
      disabled: Boolean,
      limit: {
        type: Number,
        default: 0
      },
      stopKeyBoardEvent: Boolean
    },

    computed: {
      splitItems() {
        const result = [];
        const items = this.items.slice();
        let row = 0;
        let hasRest = items.length > 0;
        while (hasRest) {
          for (let i = 0; i < this.columnCount; i++) {
            if (!items.length) {
              hasRest = false;
              break;
            }
            const item = items.shift();
            if (!result[row]) {
              result[row] = [];
            }
            result[row].push(item);
          }
          row++;
        }
        return result;
      },
      checkboxes() {
        return this.$refs.checkbox || [];
      }
    },

    methods: {
      computeAriaLabel(cell, y, x) {
        const label = cell.ariaLabel || cell.label;
        if (this.columnCount === 1) {
          return `${label}, row ${y + 1}`;
        }
        return `${label}, row ${y + 1}, column ${x + 1}`;
      },
      handleKeyDown(event) {
        const keyCode = event.keyCode;
        const keys = AriaUtils.keys;
        const stopKeyBoardEvent = this.stopKeyBoardEvent;
        switch (keyCode) {
          case keys.down:
            this.navigateCheckbox('down');
            event.preventDefault();
            stopKeyBoardEvent && event.stopPropagation();
            break;
          case keys.up:
            this.navigateCheckbox('up');
            event.preventDefault();
            stopKeyBoardEvent && event.stopPropagation();
            break;
          case keys.left:
            this.navigateCheckbox('left');
            event.preventDefault();
            stopKeyBoardEvent && event.stopPropagation();
            break;
          case keys.right:
            this.navigateCheckbox('right');
            event.preventDefault();
            stopKeyBoardEvent && event.stopPropagation();
            break;
          case keys.home:
            this.navigateCheckbox('home');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.end:
            this.navigateCheckbox('end');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.tab:
            this.onTab(event);
            break;
        }
        this.$emit('keydown', event);
      }
    },

    created() {
      this.$on('change', (val, checkbox) => {
        this.x = checkbox.x;
        this.y = checkbox.y;
      });
    },

    watch: {
      value(value) {
        this.dispatch('ZmFormItem', 'el.form.change', [value]);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";

  @include b(checkbox-list) {
    outline: 0;
    padding-left: 4px;
    margin-left: -4px;
  }
</style>

